import { getRandomString } from "../../helpers/helpers";


export const PaginationButtons = ({ activePage, allPages, callbackFunction }) => {
  let n_page = 0;
  let buttons = [];

  let onClickFunction = function (page) {
    if (typeof callbackFunction === "function") {
      callbackFunction(page);
    }
  };

  n_page = activePage - 1;
  if (n_page > 0) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        «
      </button>
    );
  }

  n_page = activePage - 3;
  if (n_page > 0) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        {n_page}
      </button>
    );
  }

  n_page = activePage - 2;
  if (n_page > 0) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        {n_page}
      </button>
    );
  }

  n_page = activePage - 1;
  if (n_page > 0) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        {n_page}
      </button>
    );
  }

  if (allPages > 1) {
    buttons.push(
      <button
        className="page-link shadow-none active"
        key={getRandomString()}
      >
        {activePage}
      </button>
    );
  }

  n_page = activePage + 1;
  if (n_page <= allPages) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        {n_page}
      </button>
    );
  }

  n_page = activePage + 2;
  if (n_page <= allPages) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        {n_page}
      </button>
    );
  }

  n_page = activePage + 3;
  if (n_page <= allPages) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        {n_page}
      </button>
    );
  }

  n_page = activePage + 1;
  if (n_page <= allPages) {
    buttons.push(
      <button
        className="page-link shadow-none"
        key={getRandomString()}
        onClick={onClickFunction.bind(this, n_page)}
      >
        »
      </button>
    );
  }

  if ( buttons.length ) {
    return (<div className="os-pagination-wrapper">{buttons}</div>);
  } else {
    return buttons;
  }
};